<script lang="ts" setup>
import { useInterval } from "@vueuse/core";
import VText from "@magnit/core/src/components/VText/VText.vue";
import type { IPromoProduct } from "@magnit/unit-catalog/src/unit-catalog.types";
import { formatPromoDate } from "~/utils/dates";

const props = withDefaults(
  defineProps<{
    product: IPromoProduct;
    defaultInterval?: number; // ms
  }>(),
  {
    defaultInterval: 1000,
  },
);
const startDateStr = computed(() => props.product.startDate);
const endDateStr = computed(() =>
  props.product.endDate ? `${props.product.endDate}T23:59:59` : undefined,
);
const now = ref(Date.now());
const endDateTime = computed(() =>
  endDateStr.value ? new Date(endDateStr.value).getTime() : undefined,
);
const promoHasEnded = computed(() =>
  endDateTime.value ? endDateTime.value < now.value : false,
);
const text = computed(() =>
  promoHasEnded.value
    ? "Акция завершилась"
    : formatPromoDate(startDateStr.value, endDateStr.value),
);

onMounted(() => {
  useInterval(props.defaultInterval, {
    callback: () => {
      now.value = Date.now();
    },
  });
});
</script>

<template>
  <div v-if="text" class="article-due-date">
    <VText
      tag="div"
      font="body-small-regular"
      :color="promoHasEnded ? 'system-warning' : 'secondary'"
      class="article-due-date__text"
    >
      {{ text }}
    </VText>
  </div>
</template>
